<template>
  <layout-default>
    <h1>Configurações</h1>
    <div class="text-left mt-5">
      <router-link to="/ajustes/perfil">
        <div class="settings-item">Perfil</div>
      </router-link>

      <router-link to="/ajustes/disciplinas">
        <div class="settings-item">
          Disciplinas para Estudar
        </div>
      </router-link>
      <div class="settings-item" @click="handleLogout">
        Logout
      </div>
    </div>
  </layout-default>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";

export default {
  name: "Settings",
  components: {
    "layout-default": LayoutDefault
  },
  methods: {
    handleLogout() {
      this.$store.dispatch("logout").then(this.$router.push("/login"));
    }
  }
};
</script>

<style lang="scss" scoped>
.settings-item {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid lightgray;
  font-size: 1rem;
  // border-top: 1px solid gray;
  cursor: pointer;
  color: #888;

  &:hover {
    color: #5f4d7c;
  }
}
</style>
